// The same rules the API enforces (services/api/src/accounts.ts), checked
// before sending so customers see mistakes next to the field.

export const MIN_PASSWORD_LENGTH = 8;

/** Israeli number in E.164 form, or undefined. Mobile and VoIP have nine digits after the 0, landlines eight. */
export function normalizeIsraeliPhone(raw: string): string | undefined {
  const digits = raw.replace(/[\s\-().]/g, "");
  const national = /^(?:\+972|00972|972)0?(\d+)$/.exec(digits)?.[1] ?? /^0(\d+)$/.exec(digits)?.[1];
  return national && /^(?:[57]\d{8}|[2-489]\d{7})$/.test(national) ? `+972${national}` : undefined;
}

/** Trimmed name with single spaces, if it has at least two words and 2–100 characters. */
export function normalizeFullName(raw: string): string | undefined {
  const name = raw.trim().replace(/\s+/g, " ");
  return name.length >= 2 && name.length <= 100 && name.split(" ").length >= 2 ? name : undefined;
}

export function isEmail(raw: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(raw.trim());
}

/** "+972501234567" as "050-123-4567"; landlines as "03-123-4567". */
export function formatIsraeliPhone(e164: string): string {
  const national = e164.startsWith("+972") ? `0${e164.slice(4)}` : e164;
  return national.length === 10
    ? `${national.slice(0, 3)}-${national.slice(3, 6)}-${national.slice(6)}`
    : `${national.slice(0, 2)}-${national.slice(2, 5)}-${national.slice(5)}`;
}

const shekels = new Intl.NumberFormat("he-IL", { style: "currency", currency: "ILS", maximumFractionDigits: 0 });

export function formatPrice(agorot: number): string {
  return shekels.format(agorot / 100);
}

/** A download's size for people: "3.4GB", "850MB". */
export function formatFileSize(bytes: number): string {
  return bytes >= 1e9 ? `${(bytes / 1e9).toFixed(1)}GB` : `${Math.max(1, Math.round(bytes / 1e6))}MB`;
}
